// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"352":"ffb24cf0e00f7facfa88","927":"20f6b523da8bdae4efba","932":"cdc4b3733b59f64059ca"}[chunkId] + ".chunk.css";
};